goog.provide('el8.ptdata.model.med.asMap');

goog.require('el8.model.base');
goog.require('el8.util.base');
goog.require('el8.service.tz');

el8.ptdata.model.med.asMap = function(item) {

    if (!item.is('MedOrder')) { return {}; }

    var addlData = item.getMetadata() || {};

    var result = item.asMap(true);

    // Presence of documenting_personnel tells us this is NOT an Rx
    result['is_document_med'] = (item.getDocumentingPersonnelId() !== null);

    // Temp info from order form
    var setOptKey = el8.util.setOptKey;

    // Related to ePrescribing -- gets saved even when not signed off, so we 
    // only need to send up once
    setOptKey(result, 'packaged_med_id', addlData['packaged_med_id']);
    setOptKey(result, 'eligibility_id', addlData['eligibility_id']);

    var name = addlData['manual_prescribing_physician_name'];
    setOptKey(result, 'prescribing_physician_name', (function() {
        if (name && (name.trim().replace(/\./g,"").toLowerCase() === 'dr')) {
            return null;  // If the prescriber name is empty
        }
        return name || null;
    })());

    var hasMedName = setOptKey(result, 'medication_name', addlData['manual_medication_name']);
    if (hasMedName) { 
        setOptKey(result, 'medication_strength', addlData['manual_medication_strength']);
    }
    result['medication_is_prescription'] = (addlData['medication_is_prescription'] !== undefined) ?
        (addlData['medication_is_prescription'] !== false) : item.isPrescription();
    result['medication_is_controlled'] = (addlData['medication_is_controlled'] === true);

    result['is_signed_off'] = item.isSignedOff();

    result['is_thread_permanent'] = (addlData['is_thread_permanent'] !== undefined) ?
        addlData['is_thread_permanent'] : item.isThreadPermanent();

    // Gather the basic set of additional meta data
    var metadata = {};

    // Just save the txStartDate string right now (can be sent back down to client)
    setOptKey(metadata, 'tx_start_date', addlData['tx_start_date']);
    if (addlData['old_medication_id'] || addlData['old_medication_name']) {
        var hasId = setOptKey(metadata, 'old_medication_id', addlData['old_medication_id']);
        if (!hasId) {
            setOptKey(metadata, 'old_medication_name', addlData['old_medication_name']);
            setOptKey(metadata, 'old_medication_strength', addlData['old_medication_strength']);
        }
        setOptKey(metadata, 'old_medication_is_prescription', 
                (addlData['old_medication_is_prescription'] !== false));
        setOptKey(metadata, 'old_medication_is_controlled', 
                (addlData['old_medication_is_controlled'] !== false));
        setOptKey(metadata, 'old_directions', addlData['old_directions']);
    }

    // This is data we only send to the server for updating if the MedOrder is being signed off
    if (item.isSignedOff()) {

        // Only on sign off is the actual denial sent, and intxns recorded
        setOptKey(result, 'denial_note', addlData['denial_note']);
        setOptKey(result, 'refill_request_id', addlData['refill_request_id']);
        setOptKey(result, 'intxns_info', addlData['intxns_info']);

        // We need a treatment date to save an additional document med
        if (addlData['tx_start_date']) {
            // Only save additional med if we have old med info...
            if (addlData['old_medication_id'] || addlData['old_medication_name']) {

                // Over-ride and set tx_start_date to the format the server prefers
                metadata['tx_start_date'] = el8.service.tz.asServerFormatDate(addlData['tx_start_date']);
                result['addl_doc_med'] = metadata;

            // If no med info, we do not send an additional document med; just start date on the 'result'
            } else {
                result['tx_start_date'] = el8.service.tz.asServerFormatDate(addlData['tx_start_date']);
            }
        }
    // Otherwise, we just send up metadata for re-populating form later
    } else {

        setOptKey(metadata, 'denial_note', addlData['denial_note']);
        setOptKey(metadata, 'refill_request_id', addlData['refill_request_id']);
        setOptKey(metadata, 'intxns_info', addlData['intxns_info']);

        setOptKey(metadata, 'related_thread_id', item.getThreadId());
        if (!el8.util.isEmptyObj(metadata)) {
            result['metadata'] = metadata;
        }
    }

    return result;

};


